import * as React from 'react';

import { ColumnHeader } from '../ComposableTable';
import ComposableTableHeader, { ComposableTableHeaderSortProps } from '../ComposableTableHeader';

export function getHeader(
  header: ColumnHeader,
  index: number,
  sortProps?: ComposableTableHeaderSortProps,
  topOffset?: number,
  spreadsheet?: boolean
) {
  return (
    <ComposableTableHeader
      columnHeader={header}
      sortProps={sortProps}
      key={header.name}
      topOffset={topOffset}
      index={index}
      spreadsheet={spreadsheet}
    />
  );
}
